import { BnplService } from "../@types";

export type ExtendedBnplService = BnplService & {
  onPress?: () => void;
  status: "unavailable" | "available";
};

const MARKETPLACE_STATUS = process.env.REACT_APP_ENABLE_MARKETPLACE === "true" ? "available" : "unavailable";

export const bnplServices: ExtendedBnplService[] = [
	{
		bnpl_service_name: "Aviation",
		status: "available",
		key: "aviation",
		description: "Book flights instantly and pay over time.",
		display_img:
			"https://images.unsplash.com/photo-1517999349371-c43520457b23?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cGxhbmV8ZW58MHx8MHx8fDA%3D",
		thumbnails:
			"https://images.unsplash.com/photo-1517999349371-c43520457b23?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cGxhbmV8ZW58MHx8MHx8fDA%3D",
	},
	{
		bnpl_service_name: "Marketplace",
		status: MARKETPLACE_STATUS,
		key: "marketplace",
		description: "Shop your favorite products and pay in installments.",
		display_img:
			"https://images.unsplash.com/photo-1713646778050-2213b4140e6b?q=80&w=3131&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		thumbnails:
			"https://images.unsplash.com/photo-1713646778050-2213b4140e6b?q=80&w=3131&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
	},
	{
		bnpl_service_name: "Education",
		status: "unavailable",
		key: "education-bnpl",
		description: "Start learning now and spread the cost over time.",
		display_img:
			"https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGVkdWNhdGlvbnxlbnwwfHwwfHx8MA%3D%3D",
		thumbnails:
			"https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGVkdWNhdGlvbnxlbnwwfHwwfHx8MA%3D%3D",
	},
	{
		bnpl_service_name: "Healthcare",
		status: "unavailable",
		key: "healthcare-bnpl",
		description: "Access quality healthcare now, pay later.",
		display_img:
			"https://images.unsplash.com/photo-1512677859289-868722942457?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		thumbnails:
			"https://images.unsplash.com/photo-1512677859289-868722942457?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
	},
	{
		bnpl_service_name: "Real Estate",
		status: "unavailable",
		key: "real-estate-bnpl",
		description: "Move in now and pay your rent over time.",
		display_img:
			"https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1973&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		thumbnails:
			"https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1973&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
	},
	{
		bnpl_service_name: "HR - Integrated Lending",
		status: "unavailable",
		key: "hr-bnpl",
		description:
			"Empower your staff with salary-linked loans and BNPL options.",
		display_img:
			"https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
		thumbnails:
			"https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
	},
];
